import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 120000, // a dead connection must end in a message, not a spinner; uploads and receipts set their own
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};


export const DEVICE_KEY_STORAGE = 'inny.deviceKey';
export const SESSION_STORAGE = 'inny.session';

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    try {
      const deviceKey = localStorage.getItem(DEVICE_KEY_STORAGE);
      if (deviceKey) requestConfig.headers['X-Inny-Key'] = deviceKey;
      const session = localStorage.getItem(SESSION_STORAGE);
      if (session && !clerkSession) requestConfig.headers.Authorization = `Bearer ${session}`;
    } catch {
      /* storage unavailable */
    }
    if (clerkSession) {
      try {
        const token = await clerkSession.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get token:', err);
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;

// An expired or revoked Odoo session: tell the auth provider to show the login.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error?.config?.url || '';
    if (error?.response?.status === 401 && !url.includes('auth/login')) {
      try {
        if (localStorage.getItem(SESSION_STORAGE)) window.dispatchEvent(new Event('inny:unauthorized'));
      } catch {
        /* ignore */
      }
    }
    return Promise.reject(error);
  }
);
